import PropTypes from 'prop-types';
import { getDestInfoUrlObj } from 'src/common/utils/guideItem/getGuideItemPathname';
import ClampText from '../shared/ClampText';
import ChevronRightLink from '../shared/link/ChevronRightLink';

import css from './pageTitles.module.scss';

const PageTitles = ({
  className,
  title,
  subtitle,
  description,
  affiliate,
  genres,
  isGame,
}) => {
  const subtitleObject = !isGame && (affiliate || genres);
  return (
    <div className={className}>
      <ClampText className={css.pageTitle} clamp={2}>
        <h1 data-testid="profileTitle" title={title}>
          {title}
        </h1>
      </ClampText>
      {subtitleObject ? (
        <ChevronRightLink
          data-testid="profileSubtitleLink"
          to={getDestInfoUrlObj(subtitleObject.destinationInfo)}
          chevronClassName={css.chevron}
        >
          <h2 className={css.pageSubtitle} data-testid="profileSubtitle">
            {subtitleObject.displayName}
          </h2>
        </ChevronRightLink>
      ) : (
        <h2 className={css.pageSubtitle} data-testid="profileSubtitle">
          {subtitle}
        </h2>
      )}
      {description && (
        <h2 className={css.description} data-testid="profileTitleDescription">
          <ClampText clamp={4} className={css.description}>
            {description}
          </ClampText>
        </h2>
      )}
    </div>
  );
};

PageTitles.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  affiliate: PropTypes.object,
  genres: PropTypes.object,
  isGame: PropTypes.bool,
};

export default PageTitles;
